import { render, staticRenderFns } from "./CreateDigitalMailRestriction.vue?vue&type=template&id=da96b6b2&"
import script from "./CreateDigitalMailRestriction.vue?vue&type=script&lang=js&"
export * from "./CreateDigitalMailRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports